<template>
  <router-link :to="localizedTo" v-bind="$attrs">
    <slot></slot>
  </router-link>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import i18n from "@/i18n";

export default {
  name: 'router-link-locale',
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  setup(props) {
    const route = useRoute();

    const currentLocale = computed(() => {
      return route.params.locale || i18n.global.locale.value;
    });

    const localizedTo = computed(() => {
      if (typeof props.to === 'string') {

        return { name: props.to, params: { locale: currentLocale.value } };
      }
      return {
        ...props.to,
        params: {
          ...props.to.params,
          locale: currentLocale.value
        }
      };
    });

    return {
      localizedTo
    };
  }
};
</script>
